import React from 'react';
import VideoChat from '../components/VideoChat/index';

const VideoCall = (props) => {
  return (
    <>
      <VideoChat />
    </>
  );
};

export default VideoCall;
